import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ScheduledReportGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
				
		this.admin = false;		
				
		var scheduledReportGrid = this;
		setTimeout(function(){
			scheduledReportGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var scheduledReportGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 300px;' + (scheduledReportGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (scheduledReportGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							if (scheduledReportGrid.admin) {								
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
								if (selectedCompany) {
									ElementUtil.query(toolbar, 'generate').disabled = false;									
								} else {
									ElementUtil.query(toolbar, 'generate').disabled = true;									
								}
							}
							actionRefresh();
						}
					}					
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					label: 'Status',
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'vaadin-checkbox',
					itemid: 'filterShowCompanies',
					style: 'display: none;',
					label: 'Show Company Reports'
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'generate',
					theme: 'primary',
					'class': 'spacer-toolbar-item',						
					permissions: ['ADMIN_SCHEDULED_REPORTS:WRITE', 'SCHEDULED_REPORTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:timer', ' Schedule')						
					],
					listeners: {
						click: function() {
							actionGenerate();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_SCHEDULED_REPORTS:READ', 'SCHEDULED_REPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:file-text-o', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'toggleStatus',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_SCHEDULED_REPORTS:READ', 'SCHEDULED_REPORTS:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:flip-h', ' Toggle Status')						
					],
					listeners: {
						click: function() {
							actionToggleStatus(grid.selectedItems[0]);
						}
					}					
				},												
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_SCHEDULED_REPORTS:DELETE', 'SCHEDULED_REPORTS:DELETE'],
							'class': 'spacer-toolbar-item',
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});		
				
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'reportTypeDescription',
					header: 'Report Type',
					width: '7em'
				},	
				{						
					path: 'unitSelectionTypeDescription',
					header: 'Unit Selection Type',
					'text-align': 'center',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.unitSelectionTypeDescription) {													
							root.innerHTML = rowData.item.unitSelectionTypeDescription;					
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},		
				{
					path: 'descriptionOfInterval',
					header: 'Schedule',
					'text-align': 'center',
					width: '9em'
				},				
				{						
					path: 'lastRanDts',
					header: 'Last Run Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.lastRanDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {					  
						ElementUtil.query(toolbar, 'details').disabled = false;						
						ElementUtil.query(toolbar, 'delete').disabled = false; 										
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false; 										
					} else {						
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true; 
						ElementUtil.query(toolbar, 'toggleStatus').disabled = true; 
					}
				}
			}
		});	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
										
						var selectedCompany = null;
						if (scheduledReportGrid.admin) {
							selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							
							if (!selectedCompany) {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Validation', 'Select a company first.', {									
										theme: 'error'
								});
								return;
							}
						}
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							status: ElementUtil.query(toolbarFilter, 'status').value
						};
						
						if (selectedCompany) {
							grid.currentFilter.companyId = selectedCompany;
						}
						
						var showCompanyReports = ElementUtil.query(toolbarFilter, 'filterShowCompanies').checked;
						if (showCompanyReports) {
							grid.currentFilter.showCompanyReports = ElementUtil.query(toolbarFilter, 'filterShowCompanies').checked;
						}						

						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						Service.getReportService().getScheduledReports(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {		
					if (!scheduledReportGrid.admin) {
						pagingToolbar.loadCurrentPage();					
					}
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'scheduled-reports',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'scheduled-reports.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		scheduledReportGrid.append(flexLayout);		
			
		if (scheduledReportGrid.admin) {
			ElementUtil.query(toolbar, 'generate').disabled = true;
		}	
			
		var showCompanyReportsFilter = function() {
			if (!scheduledReportGrid.admin) {
				Service.getUserService().getCurrentUser().then(function(user){
					if(user.hasPermission('REPORTS:VIEW_COMPANY_RESOURCE')) {
						ElementUtil.query(toolbarFilter, 'filterShowCompanies').style = '';
					}
				});
			}
		};		
		showCompanyReportsFilter();
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(scheduledReportGrid, toolbarFilter, ['filterCompany','status','filterShowCompanies'], actionRefresh);
					
		var actionGenerate = function() {
						
			var generateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Schedule Report',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						generateWin.show();
						
						var genForm = ElementUtil.create({
							tag: 'dl-report-generate-form',
							scheduled: true,
							listeners: {
								cancel: function() {
									generateWin.close();
								},
								success: function() {
									actionRefresh();
									generateWin.close();
								}
							}
						});
						if (scheduledReportGrid.admin) {
							var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
							genForm.setCompanyId(selectedCompany);
						} else {
							Service.getCompanyService().getCurrentCompany().then(function(companyAll){								
								genForm.setCompanyId(companyAll.company.companyId);
							});
						}
						
						
						generateWin.addToContentElement(genForm);
					}
				}
			});
			
		};			
		
		var actionDetails = function(record) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();
						
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});
						
						var updateDetails = function(detail) {
							var data = [
								{
									key: 'Schedule Details',
									value: '-',
									section: true
								},			
								{
									key: 'Schedule Report Id',
									value: detail.scheduleReportId
								},								
								{
									key: 'Report',
									value: detail.reportType
								},
								{
									key: 'Report Description',
									value: detail.reportTypeDescription
								},
								{
									key: 'Unit Selection Type',
									value: detail.unitSelectionTypeDescription ? detail.unitSelectionTypeDescription : 'N/A'
								},
								{
									key: 'Report Days in the Past',
									value: detail.reportDaysInPast ? detail.reportDaysInPast : 'Previous Day'
								},
								{
									key: 'Report Interval',
									value: detail.descriptionOfInterval
								},								
								{
									key: 'Last Run Date',
									value: detail.lastRanDts ? TimeUtil.formatDateStandard(detail.lastRanDts) : 'N/A'
								},
								{
									key: 'Failed Count Since Success',
									value: detail.failCountSinceSuccess
								},
								{
									key: 'Last Failed Message',
									value: detail.lastFailedMessage
								},
								{
									key: 'Create User',
									value: detail.createUser
								},
								{
									key: 'Create Date',
									value: TimeUtil.formatDateStandard(detail.createDts)
								},
								{
									key: 'Update User',
									value: detail.updateUser
								},
								{
									key: 'Last Update Date',
									value: TimeUtil.formatDateStandard(detail.updateDts)
								}					
							];						

							//outputs
							data.push({
									key: 'Outputs',
									value: '-',
									section: true
							});
							detail.outputs.forEach(function(output) {
								data.push({
									key: 'Transmission Type',
									value: output.transmissionType
								});
								data.push({
									key: 'Format',
									value: output.format
								});
								
								data.push({
									key: 'Output Options',
									value: '-------------'
								});

								for (var key in output.options) {
									data.push({
										key: key,
										value: output.options[key]
									});
								}
								
							});

							if (!ElementUtil.isEmpty(detail.options)) {
								data.push({
									key: 'Options',
									value: '-',
									section: true
								});

								for (var key in detail.options) {
									data.push({
										key: key,
										value: detail.options[key]
									});
								}
							}

							detailTable.updateDetails(data);							
				
						};
						
						var detailedLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	
	
						var unitsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [
								{						
									path: 'referenceTypeDescription',
									header: 'Reference Type',
									width: '7em'
								},
								{						
									path: 'referenceNo',
									header: 'Unit Reference No',
									width: '7em'
								},
								{						
									path: 'unitId',
									header: 'Unit Id',
									width: '7em'
								},
								{						
									path: 'reportingPeriods',
									header: 'Reporting Periods',
									width: '12em',
									renderer: function(root, column, rowData) {
										if (rowData.item.reportingPeriods && rowData.item.reportingPeriods.length > 0) {
											var timeperiods = [];
											rowData.item.reportingPeriods.forEach(function(rp){
												var startDate = TimeUtil.parseDate(rowData.item.startDts);	
												var endDate = TimeUtil.parseDate(rowData.item.endDts);														
												timeperiods.push(
													'Start: ' + TimeUtil.formatDateStandard(startDate) + '<br>' +  													
													'End: '  + TimeUtil.formatDateStandard(endDate)
												);
											});
																						
											root.innerHTML = timeperiods.join('<br><br>');					
										} else {
											root.innerHTML = 'N/A';
										}
									}
								}
							]
						});
						
						var unitFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-text-field',
									itemid: 'filterUnitRefNo',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Unit Reference No',
									placeholder: 'Contains',
									listeners: {
										input: {
											fn: function() {
												unitPagingToolbar.loadCurrentPage();
											},
											buffer: 2000
										}
									}
								}
							]
						});

						var unitPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 50,
							postinit: function(element) {
								element.grid = unitsGrid;
								element.loader = function(backingGrid, pageNumber, pagebar) {
									var pageRange = pagebar.pullRange();
									var loadMask = unitsGrid.showLoading();

									var loadData = function() {

										unitsGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
											filterField: 'referenceNo',
											filterValue: ElementUtil.query(unitFilterToolbar, 'filterUnitRefNo').value
										};

										var successHandler = function(records) {
											loadMask.remove();
											unitsGrid.activeItem = null;						
											unitsGrid.items = records.data;

											unitPagingToolbar.totalRecords = records.totalNumber;
											unitPagingToolbar.updatePager();						
										};

										Service.getReportService().getScheduledReportUnits(record.scheduleReportId, unitsGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();
								};
							},
							listeners: {
								ready: function() {					
									unitPagingToolbar.loadCurrentPage();					
								}
							}

						});							

						
						var unitLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								unitFilterToolbar,
								unitsGrid,
								unitPagingToolbar
							]
						});

						var groupsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'groupName',
									header: 'Group Name',
									flexGrow: 1
								},
								{
									path: 'groupCode',
									header: 'Group Code',
									width: '8em'
								},
								{
									path: 'tagExpression',
									header: 'Tag Expression',
									width: '12em'
								}
							]
						});

						var groupPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 50,
							postinit: function(element) {
								element.grid = groupsGrid;
								element.loader = function(backingGrid, pageNumber, pagebar) {
									var pageRange = pagebar.pullRange();
									var loadMask = groupsGrid.showLoading();

									groupsGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'groupName',
										sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC'
									};

									var successHandler = function(records) {
										loadMask.remove();
										groupsGrid.activeItem = null;
										groupsGrid.items = records.data;

										groupPagingToolbar.totalRecords = records.totalNumber;
										groupPagingToolbar.updatePager();
									};

									Service.getReportService().getScheduledReportBulkGroups(record.scheduleReportId, groupsGrid.currentFilter).then(function(records){
										successHandler(records);
									});
								};
							},
							listeners: {
								ready: function() {
									groupPagingToolbar.loadCurrentPage();
								}
							}
						});

						var groupLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								groupsGrid,
								groupPagingToolbar
							]
						});
						
						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							listeners: {
								ready: function(e) {									
									tabPanel.addTabs([
										{
											'tab-title': 'Schedule',
											tag: 'div',
											style: 'height: 100%;',
											children: [														
												detailedLayout												
											]
										},
										{
											'tab-title': 'Custom Selection Units',
											tag: 'div',
											style: 'height: 100%;',
											children: [		
												unitLayout
											]
										},
										{
											'tab-title': 'Groups',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												groupLayout
											]
										}
									]);
								}
							}
						});
						
						detailWin.addToContentElement(tabPanel);
						
						updateDetails(record);						
						
					}
				}
			});			
		};			
		
		var actionToggleStatus = function(record) {
			if (record.activeStatus === 'A') {
				var loadMask = grid.showLoading('Inactivating Scheduled Report...');

				Service.getReportService().inactivateReport(record.scheduleReportId)
				.then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Inactivated Scheduled Report', {									
						theme: 'success'
					});
					actionRefresh();
				})
				.catch(function(){
					loadMask.remove();
				});					
			} else {
				var loadMask = grid.showLoading('Activating Scheduled Report...');

				Service.getReportService().activateReport(record.scheduleReportId)
				.then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Activated Scheduled Report', {									
						theme: 'success'
					});
					actionRefresh();
				})
				.catch(function(){
					loadMask.remove();
				});				
			}
			
		};
			
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected scheduled report?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Scheduled Report...');

							Service.getReportService().deleteScheduledReport(record.scheduleReportId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Scheduled Report', {									
									theme: 'success'
								});
								actionRefresh();
							})
							.catch(function(){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};					
	
		
	}
	
}
customElements.define('dl-scheduled-report-grid', ScheduledReportGrid);

